// src/pages/HorecaHub/components/HorecaHubMetaverseAnimatedUniverse.jsx
import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHotel,
  faUtensils,
  faMugHot,
  faTruck,
  faUsers,
  faConciergeBell,
  faBed,
  faBowlFood,
  faHandshake,
} from "@fortawesome/free-solid-svg-icons";

const stakeholders = [
  { id: 1, icon: faHotel, label: "Hotels" },
  { id: 2, icon: faUtensils, label: "Restaurants" },
  { id: 3, icon: faMugHot, label: "Cafes & Bars" },
  { id: 4, icon: faTruck, label: "Suppliers" },
  { id: 5, icon: faUsers, label: "Guests" },
  { id: 6, icon: faConciergeBell, label: "Front Desk & Service" },
  { id: 7, icon: faBed, label: "Housekeeping" },
  { id: 8, icon: faBowlFood, label: "Kitchen & Chefs" },
  { id: 9, icon: faHandshake, label: "Partners & Vendors" },
];

const HorecaHubMetaverseAnimatedUniverse = () => {
  const radius = 200; // distance from center to icons

  return (
    <div className="relative w-full max-w-4xl h-[500px] mx-auto mt-12 flex items-center justify-center overflow-visible">
      {/* Rotating circle frame */}
      <motion.div
        className="absolute w-[420px] h-[420px] rounded-full border-4 border-amber-600"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 40, ease: "linear" }}
      />

      {/* Stakeholders evenly distributed */}
      {stakeholders.map((s, i) => {
        const angle = (i / stakeholders.length) * 2 * Math.PI; // angle in radians
        const x = Math.cos(angle) * radius;
        const y = Math.sin(angle) * radius;

        return (
          <motion.div
            key={s.id}
            className="absolute flex flex-col items-center"
            style={{
              top: "50%",
              left: "50%",
              x, // initial x offset
              y, // initial y offset
              translateX: "-50%",
              translateY: "-50%",
            }}
            animate={{
              y: [y - 10, y + 10, y - 10], // vertical floating relative to circle
            }}
            transition={{
              repeat: Infinity,
              duration: 4,
              delay: i * 0.2,
              ease: "easeInOut",
            }}
          >
            <motion.div
              whileHover={{ scale: 1.3, rotate: 12 }}
              className="bg-white shadow-lg rounded-full p-4"
            >
              <FontAwesomeIcon icon={s.icon} className="text-amber-700 text-2xl" />
            </motion.div>
            <span className="mt-2 text-white text-sm font-medium text-center drop-shadow-md">
              {s.label}
            </span>
          </motion.div>
        );
      })}

      {/* Center core */}
      <motion.div
        className="absolute w-36 h-36 rounded-full bg-amber-700 text-white flex items-center justify-center text-lg font-bold shadow-2xl z-10"
        animate={{ scale: [1, 1.1, 1] }}
        transition={{ repeat: Infinity, duration: 3 }}
      >
        <div className="text-center">
          <div className="text-4xl mb-1">🛎️</div>
          <div>HorecaVerse</div>
        </div>
      </motion.div>
    </div>
  );
};

export default HorecaHubMetaverseAnimatedUniverse;